// extracted by mini-css-extract-plugin
export var card = "smD4a";
export var cta = "Xkru4";
export var description = "_9pXyY";
export var root = "Ac+nx";
export var title = "AFDS5";